import { render, staticRenderFns } from "./GetInTouch.vue?vue&type=template&id=e28e61e0&scoped=true&"
import script from "./GetInTouch.vue?vue&type=script&lang=js&"
export * from "./GetInTouch.vue?vue&type=script&lang=js&"
import style0 from "./GetInTouch.vue?vue&type=style&index=0&id=e28e61e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28e61e0",
  null
  
)

export default component.exports